// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from 'reportWebVitals';
import { ThemeProvider } from 'styled-components';
import { AuthContext } from '@tls/auth';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import { logo, SplashLoading } from 'utilities/logo';
import { setAssetPath } from '@stencil/core';
import { getIconSetRegistry } from '@trumpf/ux.ui-community/dist/collection/components/iconset/iconset-registry';
import { defineCustomElements as defineUxUi } from '@trumpf/ux.ui/loader/index.es2017.js'; // loader/index.js is the es5 build, breaks prop defaults in ux.ui 7.8
import { defineCustomElements as defineUxUiCommunity } from '@trumpf/ux.ui-community/loader';
import { defineCustomElements as defineUxNotifications } from '@trumpf/ux.notifications/loader'; // aliased to the es2017 loader in vite.config.ts
import 'index.css';
import '@trumpf/ux.ui/dist/ux-ui/ux-ui.css';
import '@trumpf/ux.ui-community/dist/ux-ui-community/ux-ui-community.css';
import '@trumpf/ux.notifications/uxn-notifications.css';
import App from 'App';
import { DefaultTheme } from '@tls/treact-ui';
import Style from '@tls/treact-ui/style';
import { TreactNativeScrollStyles } from 'components/common/scroll/TreactNativeScrollStyles';

const accessPath = globalThis.origin;
setAssetPath(accessPath);
getIconSetRegistry().addSet('uic', name => `${accessPath}/icons/icons.svg#${name}`);
// ux.ui needed by app-header-neo (ux-icon, ux-button)
defineUxUi();
defineUxUiCommunity();
defineUxNotifications();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={DefaultTheme}>
        <Style />
        <TreactNativeScrollStyles />
        <AuthContext.Provider logo={logo} progressBar={<SplashLoading />}>
          <App />
        </AuthContext.Provider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
